import StatusPill from "./statusPill";

import React from 'react';
import {
  Users as UsersIcon,
  CheckCircle2,
  XCircle,
  Phone,
  Mail,
  Soup,

} from 'lucide-react';
import {  useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from "../context/AuthContext";
const UserCard = ({ user }) => {
  // const baseUrl = 'http://localhost:5000';
  const baseUrl = 'https://api.codedmastery.com';
  const { logout } = useAuth();
   const token = localStorage.getItem('token');
    const queryClient = useQueryClient();
     

  const handleBlocking = useMutation({
 
  
 mutationFn: async (user) => {
  // console.log('user is == \n',user.uid,'\n')
  // console.log("user id ===",user._id)
      const res = await fetch(`${baseUrl}/auth/block/${user.uid}`, { 
        method: 'POST',
            headers:{
             'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
            },
      
      
      });
      if (!res.ok) throw new Error('Block failed');
      if(res.status === 401){
      logout();
      navigator('/login');
    }

      return res.json();
    },
    
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users'] });
    },

})
const handleActivation = useMutation({
  mutationFn:async(user)=>{

    // console.log('user id == ',user.uid)
    const res = await fetch(`${baseUrl}/auth/approve/${user.uid}`, { 
        method: 'POST',
            headers:{
             'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            }, 
             body: JSON.stringify({
            subScription : user.subscription || 'basic',
             }),
 
      });
      if(!res.ok){
        throw new Error('Activation failed');
      }
      return res.json();
  },
  onSuccess:()=>{
    
    queryClient.invalidateQueries({queryKey:['user']})
    alert('user activated successfully')
  },

})

  return(
  <div className="glass-panel glow rounded-3xl p-4 border border-white/10 flex flex-col gap-3">
    <div className="flex items-center justify-between gap-3">
      <div className="flex items-center gap-3 min-w-0">
        <div className="h-11 w-11 rounded-full bg-gradient-to-br from-purple-500 to-cyan-400 flex items-center justify-center text-sm font-semibold text-slate-900">
          {(user.name || 'User')
            .split(' ')
            .map((n) => n[0])
            .join('')
            .slice(0, 2)
            .toUpperCase()}
        </div>
        <div className="min-w-0">
          <p className="text-white font-semibold leading-tight break-words">{user.name || 'N/A'}</p>

          
        </div>
      </div>
      <div className="shrink-0">
        <StatusPill status={user.status || 'pending'} />
      </div>
    </div>
    <div className="flex  w-[60%] flex-col  gap-2 text-xs text-slate-300 truncate">
      <div className="text-xs text-slate-400 flex items-center gap-1 truncate">
      <Phone className="h-3.5 w-3.5 text-emerald-200 shrink-0" />
      <span className="truncate">{user.phone || 'No phone'}</span>
      </div>
     <p className="text-xs text-slate-400 flex items-center gap-1 truncate top-1">
            <Mail className="h-3.5 w-3.5 text-cyan-200 shrink-0" />
            <span className="truncate">{user.email || 'No email'}</span>
            
         </p>

     <p className="text-xs text-slate-400 flex items-center gap-1 truncate top-1">
            <Soup className="h-3.5 w-3.5 text-cyan-200 shrink-0" />
            <span className="truncate">{user.course_name || 'No course'}</span>
            
         </p>
         
    </div>
    {user.status === 'ACTIVE' && (
      <button onClick={()=>handleBlocking.mutate(user)} className='flex  items-center p-2 gap-2 text-s h-8 w-20 glass-panel  border-rose/10 rounded-xl m-left-[20%] self-end hover:text-rose-200'>
        <XCircle className="h-6 w-6   text-rose-400 hover:text-rose-200 transition" />
        {handleBlocking.isPending?'loading...':'Block' }
      </button>
    )}
    {user.status === 'BLOCKED' && (

      <button onClick={()=>handleActivation.mutate(user)} className='flex  items-center p-2 gap-2 text-xs h-8 w-23 glass-panel  border-emerald/10 rounded-xl m-left-[20%] self-end hover:text-emerald-200'>
        <CheckCircle2 className="h-7 w-7   text-emerald-400 hover:text-emerald-200 transition" />
         {handleActivation.isPending?'loading...':'Activate'}
      </button>
    )}
    


  </div>
  )
};
export default UserCard;